export default __webpack_public_path__ + "static/media/AcornOffice_37.a4eb75cc.png";